import {useContext, useEffect, useState} from 'react';
import {duration, getNexturlData} from '../../../lib/utils';
import {AppContext} from '../../../context/AppProvider';
import {apis} from '../../../services/alm';
import {Avatar, AvatarImage,toast} from 'alm-react-components';
import defaultUserImg from './../../../assets/images/user-mtbg.svg';
import { useTranslation } from 'react-i18next';
import { delteNotesReplies } from '../../../services/notes';
import { DeleteCommentModal } from '../../common/discussion-board/comment-section/DeleteCommentModal';
import { constants, Variant } from '../../../assets/constants/constants';
type PropsType = {
  commentId: string;
  setIsCommentEmpty: (value: boolean) => void
};

const NotesRepliesById = (props: PropsType) => {
  const {state} = useContext(AppContext);
  const [isAlmReplies, setIsAlmReplies] = useState([]);
  const { t } = useTranslation()

  useEffect(() => {
    const apiData = async () => {
      const res:any = await apis.getRepliesBasedOnCommentId(props?.commentId);
      let nextresult: any = []
      if (res?.links?.next) {
        nextresult = await getNexturlData(res)
      }else{
        nextresult=res?.data
      }
      setIsAlmReplies(nextresult?.filter((res:any)=>res?.attributes?.state !==constants.DELETED));
    };
    apiData();
  }, []);
  useEffect(() => {
    props.setIsCommentEmpty(false)
  }, [])
  const onDelete = (commentId: string) => {
    const payloadForReply = {
      almCommentId: props.commentId,
    };
    apis.deleteReply(commentId).then((res: any) => {
      if (res.error) {
        toast({
          description: res.error.title, variant: "error",
        })
      } else {
        toast({
          description: t('DiscussionBoard.commentDeleted'), variant: "success",
        });
        const remComment = isAlmReplies?.filter((comment: any) => {
          return comment.id !== commentId;
        });
        if (!remComment.length) {
          delteNotesReplies(payloadForReply).then((res: any) => {
            if (res?.code === Variant.success) {
              props.setIsCommentEmpty(true)
            }
          })
        }
        setIsAlmReplies(remComment)
      }
    }).catch((error: any) => {
      if (error) {
        toast({
          description: t('DiscussionBoard.commentDeleted'), variant: "error",
        });
      }
    });

  }
  return (
    <>
      {isAlmReplies?.map((res: any) => {
        return (
          <>
            <div className="grid w-full">
              <div className="flex my-8 space-x-6 lg:space-x-6 relative">
                <div className="flex-none relative">
                  <span className="relative flex h-[50px] w-[50px] shrink-0 overflow-hidden rounded-full">
                    <Avatar className="border h-[50px] w-[50px]">
                      {state?.user && state?.user?.avatarUrl != '' ? (
                        <AvatarImage src={state?.user?.avatarUrl} />
                      ) : (
                        <AvatarImage src={defaultUserImg} />
                      )}
                    </Avatar>
                  </span>
                </div>
                <div className="flex flex-col w-full">
                  <div className="flex flex-col">
                    <div className="flex flex-row  ">
                      <div className="w-2/3 text-base font-opensansBold leading-none pb-2">
                        {state?.user?.fields?.displayName
                          ? state?.user?.fields?.displayName
                          : state?.user?.name}
                      </div>
                      <div className="w-2/3 flex justify-end">
                        <DeleteCommentModal onDelete={onDelete} id={res?.id} />
                      </div>
                    </div>
                    <div>
                      <p className="text-base text-normal">{res?.attributes?.text}</p>
                    </div>
                  </div>
                  <div className="flex flex-row justify-end">
                    <div className="flex items-center text-base font-light dark:text-muted-foreground">
                      {duration(res?.attributes?.dateCreated)}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        );
      })}
    </>
  );
};

export default NotesRepliesById;
